import { Buffer } from "buffer";
import { Program } from "@coral-xyz/anchor";
import * as anchor from "@coral-xyz/anchor";
import { Fartlab } from "idl/types/fartlab";
// import { Fartlab } from "target/types/fartlab.ts";

/**
 * Derives the PDA based on a name and uuid
 */
export async function generatePDA(
    program: Program<Fartlab>,
    name: string,
    uuid?: string,
    owner?: anchor.web3.PublicKey
) {
    const seeds = uuid
      ? owner
        ? [Buffer.from(name), Buffer.from(uuid), owner.toBuffer()] // ✅ Use all three if owner is present
        : [Buffer.from(name), Buffer.from(uuid)] // ✅ Use name + uuid if owner is not provided
      : [Buffer.from(name)]; // ✅ Use only name if uuid is missing

    const [pda] = anchor.web3.PublicKey.findProgramAddressSync(seeds, program.programId);
    return pda;
}